import { useDocumentInstance } from 'bridge';
import { Competition } from 'business';

export default function useCompetition(competitionId?: string) : Competition | null | undefined {
    return useDocumentInstance('competitions', competitionId);
}
